'use strict';

exports.__esModule = true;
exports.getPatternBlob = getPatternBlob;

var _ItemTypes = require('../types/ItemTypes');

var _patterns = require('./patterns');

function getPatternBlob(itemType) {
  return _patterns.PATTERNS[itemType] || _patterns.PATTERNS[_ItemTypes.ITEM_TYPES.DEFAULT];
}